export default __webpack_public_path__ + "static/media/TransAnimatedLogoGif.ed048bfb.gif";